import {Card, Gratitude} from 'client';

export function isGratitude(object: any): object is Gratitude {
  return object && typeof object === 'object' && 'id' in object;
}

export type GratitudeOrCard = Gratitude | {card: Card};
